export const DASHBOARD_COLORS = {
  orders: {
    store: '#497eab',
    online: '#90CAF9',
  },
  orderValue: {
    store: '#2E7D32',
    online: '#A5D6A7',
  },
  salesMargins: {
    store: '#17b389',
    online: '#85ccb9',
  },
  returns: '#E15759',
  toShip: '#F6C1C7',
  toShipBackground: '#FDEDEC',
  shipped: '#72C7C0',
  purchasing: '#BA68C8',
  credits: '#F28E2C',
  creditsValue: '#FFB74D',
  trend: "#bde1ff",
  operationsCardBg: {
    creditQty: '#33333321',
    creditValue: '#33333321',
  },

} as const;
